import SecureLS from 'secure-ls'
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import configs from '../configs'
import { syncSharedHash } from '../helpers/sharedSession'
import modules from './modules'
import { syncNotificationSocket } from './modules/notification'

const LEGACY_PERSISTED_STATE_KEYS = ['vuex', '_secure__ls__metadata']

function removeLegacyPersistedState() {
    try {
        for (const legacyKey of LEGACY_PERSISTED_STATE_KEYS) {
            localStorage.removeItem(legacyKey)
        }
    } catch (error) {
        console.warn('Falha ao remover o estado persistido legado', error)
    }
}

removeLegacyPersistedState()

const secureStorage = new SecureLS({
    encryptionNamespace: configs.moduleName,
    isCompression: false,
})

Vue.use(Vuex)

const NON_PERSISTED_MODULES = new Set(['notification'])

function selectPersistedState(state) {
    return Object.fromEntries(
        Object.entries(state).filter((stateEntry) => !NON_PERSISTED_MODULES.has(stateEntry[0])),
    )
}

export default new Vuex.Store({
    getters: {
        getSystem(state) {
            return state.system
        },
    },
    modules,
    mutations: {
        setLanguage(state, payload) {
            // Vue.prototype.$vuetify.framework.lang.current
            state.system.language = payload
        },
    },
    plugins: [
        createPersistedState({
            key: `vuex-${configs.moduleName}`,
            reducer: selectPersistedState,
            storage: {
                getItem: (key) => secureStorage.get(key),
                removeItem: (key) => secureStorage.remove(key),
                setItem: (key, value) => secureStorage.set(key, value),
            },
        }),
        syncSharedHash,
        syncNotificationSocket,
    ],
    state() {
        return {
            system: {
                clientId: configs.id,
                language: configs.language,
                module: configs.module,
                system: configs.system,
            },
        }
    },
})
